import { useTranslation } from 'react-i18next';

interface ElementTextBlockProps {
  config: Record<string, unknown>;
}

export const ElementTextBlock = ({ config }: ElementTextBlockProps) => {
  const { t } = useTranslation('authenticated.reports');
  const text = typeof config.text === 'string' ? config.text : '';

  return (
    <div className="whitespace-pre-wrap text-sm text-foreground">
      {text || <span className="text-muted-foreground">{t('element.noTextContent')}</span>}
    </div>
  );
};
